import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Crown } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { useI18n } from "../i18n";

export default function Login() {
  const { t } = useI18n();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const user = await login(email.trim().toLowerCase(), password);
      navigate(user.role === "admin" ? "/admin" : "/vendeur");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-4 py-16">
      <div className="text-center mb-8">
        <Crown className="h-8 w-8 text-neon-green mx-auto mb-2" />
        <h1 className="font-anton text-4xl uppercase text-white">{t("log.title")}</h1>
        <p className="text-zinc-500 text-sm">{t("log.sub")}</p>
      </div>
      <form onSubmit={submit} className="space-y-4 bg-ink-surface border border-zinc-800 p-8">
        {error && <div data-testid="login-error" className="bg-red-500/10 border border-red-500/40 text-red-400 text-sm px-4 py-2">{error}</div>}
        <input data-testid="login-email" type="email" autoCapitalize="none" autoCorrect="off" spellCheck={false} value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="w-full bg-ink border border-zinc-700 text-white px-4 py-3 focus:outline-none focus:border-neon-green" />
        <input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder={t("log.password")} className="w-full bg-ink border border-zinc-700 text-white px-4 py-3 focus:outline-none focus:border-neon-green" />
        <button type="submit" data-testid="login-submit" disabled={loading} className="w-full bg-neon-green text-black font-anton uppercase text-lg py-3 glow-green hover:bg-neon-greenDark transition-colors disabled:opacity-50">{loading ? "..." : t("log.submit")}</button>
      </form>
      <p className="text-center text-zinc-500 text-sm mt-6">{t("log.notYet")} <Link to="/register" data-testid="goto-register-link" className="text-neon-green font-semibold">{t("log.create")}</Link></p>
    </div>
  );
}
